import { IListCellUi } from '../../list-cell/model';

/**
 * Splice cells from provided array of cells by condition function
 *
 * @WARN will mutate provided array
 * @param cells
 * @param extractFn - condition to extract
 */
export function spliceCells(
  cells: IListCellUi[],
  extractFn: (cell: IListCellUi, index: number) => boolean,
): IListCellUi[] {
  const filteredCells: IListCellUi[] = [];

  for (let i = cells.length - 1; i >= 0; i--) {
    if (extractFn(cells[i], i)) {
      filteredCells.push(cells[i]);

      cells.splice(i, 1);
    }
  }

  return filteredCells.reverse();
}
